import React from 'react';
import { useSelector } from 'react-redux';
import { getSplitFeatures } from 'packages/store/user/user.selectors';
import { ActiveSplits } from 'packages/store/user/types';
import ColorInputLegacy from './ColorInputLegacy';
import ColorInputV2 from './ColorInputV2';
import type { Props } from './shared';

const ColorInput = (props: Props) => {
    const splitFeatures = useSelector(getSplitFeatures);
    const isDsColorPickerEnabled = splitFeatures?.[ActiveSplits.studioDsColorPicker] === 'on';

    return isDsColorPickerEnabled ? <ColorInputV2 {...props} /> : <ColorInputLegacy {...props} />;
};

export default ColorInput;
